import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-skeleton',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading-skeleton.component.html',
  styleUrl: './loading-skeleton.component.scss'
})
export class LoadingSkeletonComponent {
  @Input() count = 4;
  @Input() width = '100%';
  @Input() height = '12px';
  @Input() minHeight = '0px';
  @Input() gap = '10px';
  @Input() borderRadius = '4px';
  @Input() animate = true;
  @Input() circle = false;
  @Input() lineWidths: string[] = [];

  get skeletonRows(): number[] {
    return Array.from({ length: Math.max(1, this.count) }, (_, idx) => idx);
  }

  getLineWidth(index: number): string {
    return this.lineWidths[index] ?? this.width;
  }

  get resolvedMinHeight(): string {
    if (this.minHeight !== '0px') {
      return this.minHeight;
    }
    if (typeof this.height === 'string' && this.height.includes('%')) {
      return '160px';
    }
    return '0px';
  }
}
